// extracted by mini-css-extract-plugin
export default {"container":"SchoolOverview_container__G7hqg","info":"SchoolOverview_info__Z-AoE","diagram":"SchoolOverview_diagram__qXGpd"};